import ImportListProductMediaTab from './ImportListProductMediaTab'

export default ImportListProductMediaTab
